const STATS = [
  { value: "8", label: "Pisos gestionados" },
  { value: "48", label: "Habitaciones operadas" },
  { value: "100%", label: "Propietarios cobrando puntual" },
  { value: "24h", label: "Respuesta técnica" },
];

export default function Trust() {
  return (
    <section
      data-testid="trust-section"
      className="border-y border-[#EAEAEA] bg-[#F7F7F7]"
    >
      <div className="nr-container py-14 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-10">
          <div className="max-w-xl">
            <span className="nr-eyebrow">La confianza, en cifras</span>
            <h2 className="nr-h2 mt-4">
              Propietarios que ya duermen tranquilos.
            </h2>
          </div>
          <p className="text-[15px] nr-text-soft max-w-md">
            Datos reales del portfolio THE NEXT ROOM. Operamos de forma directa,
            cercana y respondemos en persona ante cualquier incidencia.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10">
          {STATS.map((s) => (
            <div key={s.label} data-testid={`stat-${s.label}`} className="">
              <div className="nr-stat">{s.value}</div>
              <div className="mt-2 text-[13px] nr-text-soft leading-snug">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
